const devicePropertyOptions = [
  {
    label: "Is Agent",
    value: "is_agent",
  },
  {
    label: "Location",
    value: "lat_long",
  },
  {
    label: "Network",
    value: "network_name",
  },
  {
    label: "Tags",
    value: "tags",
  },
  {
    label: "Operating Hours",
    value: "override_network_operate_hours",
  },
  {
    label: "Testing Device",
    value: "testing_device",
  },
];

export { devicePropertyOptions };
